export const getUrlWithoutHash = () => {
	const sectionIndex = window.location.href.indexOf('#');

	if (sectionIndex === -1) {
		return window.location.href;
	}

	return window.location.href.slice(0, sectionIndex);
};
